import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const FallbackBlock = () => {
    return (
        <div className="mt-16 flex h-screen items-center justify-center rounded-3xl bg-white animate-out fade-out-50 sm:my-4 sm:ml-20 sm:rounded-l-3xl">
            <FontAwesomeIcon icon={faSpinnerThird} className="animate-spin text-4xl text-primary-700" />
        </div>
    );
};

export { FallbackBlock };
